import {
  Box,
  Card,
  Checkbox,
  Divider,
  List,
  ListItem,
  makeStyles,
  Popover,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  withStyles,
  Fade,
  useTheme, 
  useMediaQuery
} from '@material-ui/core';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import { Pagination } from '@material-ui/lab';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { useSelector } from 'react-redux';
import DialogConfirm from 'src/app/components/DialogConfirm';
import { MESSAGE } from 'src/app/constant/message';
import { closeDialogConfirm, showDialogConfirm } from 'src/features/uiSlice';
import { useQuery } from 'src/app/hooks/useQuery';

import { useDispatch } from 'react-redux';
import LoadingComponent from 'src/app/components/Loading';
import { PAGE_SIZE_LIST } from 'src/app/constant/config';
import { deleteMultiUsers } from 'src/features/userSlice';
import EditUserForm from './EditUser';

const StyledTableCell = withStyles(theme => ({
  head: {
    backgroundColor: theme.palette.common.white,
    color: theme.palette.common.black,
    whiteSpace: 'nowrap'
  },
  body: {
    fontSize: 14,
    wordBreak: 'break-word'
  },
  root: {
    padding: '6px'
  }
}))(TableCell);

const Results = ({ className, listUsers, getListUsersRef, currentParams }) => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const limit = isMobile ? 6 : PAGE_SIZE_LIST;
  const [selectedItem, setSelectedItem] = useState();
  const [itemCurrent, setItemCurrent] = useState();
  const totalUsers = useSelector(state => state.userSlice.totalUsers);
  const listProvinces = useSelector(state => state.provinceSlice.listProvinces);
  const [rowsSelected, setRowsSelected] = useState([]);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [openEditModal, setOpenEditModal] = useState(false);

  const [params, setParams] = useState({
    page: currentParams?.page || 1,
    page_size: limit
  });

  const query = useQuery();

  useEffect(() => {
    if (currentParams) {
      setParams({
        ...currentParams,
        page: currentParams?.page || 1,
        page_size: currentParams?.page_size || PAGE_SIZE_LIST
      });
    }
  }, [currentParams]);

  useEffect(() => {
    const pageFromQuery = query.get('page');
    const pageSizeFromQuery = query.get('page_size');

    if (pageFromQuery) {
      setParams(prev => ({
        ...prev,
        page: Number(pageFromQuery)
      }));
    }
    if (pageSizeFromQuery) {
      setParams(prev => ({
        ...prev,
        page_size: Number(pageSizeFromQuery)
      }));
    }
  }, [query]);

  const handleClickMenu = (event, user) => {
    setAnchorEl(event.currentTarget);
    setItemCurrent({
      id: user.id,
      username: user.username,
      full_name: user.full_name,
      email: user.email,
      phone: user.phone,
      citizen_id: user.citizen_id,
      address: user.address,
      status: user.status
    });
    setSelectedItem(user.id);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };
  const open = Boolean(anchorEl);

  const closeModal = () => {
    setOpenEditModal(false);
  };

  const handleDeleteMember = () => {
    dispatch(showDialogConfirm());
    handleCloseMenu();
  };

  const handleDeleteMultiUsers = () => {
    dispatch(showDialogConfirm());
    handleCloseMenu();
  };

  const confirmDelete = () => {
    const listId = rowsSelected.length > 0 ? rowsSelected : [selectedItem];
    setRowsSelected([]);
    dispatch(closeDialogConfirm());
    dispatch(deleteMultiUsers({ user_ids: listId }));
  };

  const handleEditUser = () => {
    setOpenEditModal(true);
    handleCloseMenu();
  };

  const handlePageChange = (event, newPage) => {
    if (!getListUsersRef) return;
    const newparams = {
      ...currentParams,
      page: newPage,
      page_size: limit
    };
    setParams(newparams);
    getListUsersRef(newparams);
  };

  const checked = id => {
    return rowsSelected.indexOf(id) !== -1;
  };

  const select = driver => {
    if (rowsSelected.indexOf(driver) === -1) {
      const newSelected = [driver, ...rowsSelected];
      setRowsSelected(newSelected);
    } else {
      const newSelected = rowsSelected.filter(i => i !== driver);
      setRowsSelected(newSelected);
    }
  };

  const checkAll = () => {
    if (rowsSelected.length > 0) {
      setRowsSelected([]);
    }

    if (listUsers.length > 0 && rowsSelected.length !== listUsers.length) {
      const all = listUsers.map(item => {
        return item.id;
      });
      setRowsSelected(all);
    }
  };

  const getStatus = status => {
    const statusUser = {
      1: 'Hoạt động',
      0: 'Tạm dừng'
    };
    return statusUser[status];
  };

  const getProvinceAddress = citizenId => {
    const province = listProvinces?.find(
      province => province.id === +citizenId
    );
    return province?.name;
  };

  return (
    <>
      {openEditModal && (
        <EditUserForm open userSelected={itemCurrent} onClose={closeModal} />
      )}

      <DialogConfirm
        title={MESSAGE.CONFIRM_DELETE_USER}
        textOk={MESSAGE.BTN_YES}
        textCancel={MESSAGE.BTN_CANCEL}
        content={MESSAGE.CONTENT_DELETE_USER}
        callbackOk={() => confirmDelete()}
        callbackCancel={() => dispatch(closeDialogConfirm())}
      />
      <Card className={clsx(classes.root, className)}>
          <div>
            {rowsSelected.length > 0 && (
              <Fade in={rowsSelected.length > 0}>
               <Box style={{ overflowX: 'auto' }} minWidth={1050}>
                  <span>
                    <Checkbox
                      checked={rowsSelected.length > 0}
                      onChange={() => checkAll()}
                      color="primary"
                      inputProps={{ 'aria-label': 'secondary checkbox' }}
                    />
                  </span>

                  <span
                    onClick={handleDeleteMultiUsers}
                    className="mx-2 btnDevice"
                    color="primary"
                    variant="outlined"
                    size="small"
                  >
                    <img
                      src={`/static/iconSvg/delete-icon.svg`}
                      alt="delete"
                      style={{ paddingRight: '5px', paddingBottom: '4px' }}
                    />
                    <span className="pt-1"> Xóa </span>
                  </span>
                </Box>
              </Fade>
            )}
            <PerfectScrollbar >
              {listUsers && listUsers.length > 0 ? (
                <Box minWidth={1050}>
                  <Table>
                    {rowsSelected.length === 0 && listUsers?.length > 0 && (
                      <TableHead>
                        <TableRow>
                          <StyledTableCell width={50}>
                            <Checkbox
                              checked={rowsSelected.length > 0}
                              onChange={() => checkAll()}
                              color="primary"
                              inputProps={{
                                'aria-label': 'secondary checkbox'
                              }}
                            />
                          </StyledTableCell>
                          <StyledTableCell width={150}>Số điện thoại</StyledTableCell>
                          <StyledTableCell width={250}>Tên khách hàng</StyledTableCell>
                          <StyledTableCell width={250}>Tên đăng nhập</StyledTableCell>
                          <StyledTableCell width={80}>Vai trò</StyledTableCell>
                          <StyledTableCell width={100}>Trạng thái</StyledTableCell>
                          <StyledTableCell width={250}>Email</StyledTableCell>
                          <StyledTableCell width={500}>Địa chỉ</StyledTableCell>
                          <StyledTableCell width={150}>Tỉnh thành</StyledTableCell>
                          <StyledTableCell width={50}></StyledTableCell>
                        </TableRow>
                      </TableHead>
                    )}
                    <TableBody>
                      {listUsers.map((user, index) => (
                        <TableRow hover key={user.id}>
                          <StyledTableCell
                            style={{ maxWidth: '35px' }}
                            onClick={() => select(user?.id)}
                          >
                            <Checkbox
                              checked={checked(user.id)}
                              onChange={() => select(user.id)}
                              color="primary"
                              inputProps={{
                                'aria-label': 'secondary checkbox'
                              }}
                            />
                          </StyledTableCell>
                          <StyledTableCell>
                            {user?.phone || '--'}
                          </StyledTableCell>
                          <StyledTableCell>
                            {user?.full_name || '--'}
                          </StyledTableCell>
                          <StyledTableCell>
                            {user?.username || '--'}
                          </StyledTableCell>
                          <StyledTableCell>
                            {user?.role.title || '--'}
                          </StyledTableCell>
                          <StyledTableCell>
                            {getStatus(user?.status) || '--'}
                          </StyledTableCell>
                          <StyledTableCell>
                            {user?.email || '--'}
                          </StyledTableCell>
                          <StyledTableCell>
                            {user?.address || '--'}
                          </StyledTableCell>
                          <StyledTableCell>
                            {getProvinceAddress(user?.citizen_id) || '--'}
                          </StyledTableCell>
                          <StyledTableCell>
                            <span style={{ color: '#AEB1C5' }}>
                              <MoreVertIcon
                                aria-describedby={`menu-device-${user.id}`}
                                className={`cursor-pointer hover-red`}
                                onClick={e => handleClickMenu(e, user)}
                              />
                            </span>

                            <Popover
                              className="popover-device"
                              open={open}
                              anchorEl={anchorEl}
                              onClose={handleCloseMenu}
                              anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'left'
                              }}
                              transformOrigin={{
                                vertical: 'top',
                                horizontal: 'right'
                              }}
                            >
                              <Typography>
                                <List>
                                  <ListItem className="cursor-pointer list-menu-device">
                                    <span> Reset mật khẩu </span>
                                  </ListItem>
                                  <Divider />
                                  <ListItem
                                    onClick={handleEditUser}
                                    className="cursor-pointer list-menu-device"
                                  >
                                    <span> Chỉnh sửa </span>
                                  </ListItem>
                                  <Divider />
                                  <ListItem
                                    onClick={handleDeleteMember}
                                    className="cursor-pointer list-menu-device"
                                  >
                                    <span class="text-danger"> Xóa </span>
                                  </ListItem>
                                </List>
                              </Typography>
                            </Popover>
                          </StyledTableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </Box>
              ) : (
                <div className="text-center pb-5">
                  <img src="/static/empty.png" class="justify-content-center" />
                  <h4> Danh sách trống </h4>
                </div>
              )}
            </PerfectScrollbar>
          </div>
      </Card>
      {listUsers && listUsers.length > 0 && (
        <div class="mt-3 mr-4 float-right">
          <Box
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              gap: '15px'
            }}
          >
            <Typography style={{ fontSize: '14px' }}>
              Tổng: {totalUsers}
            </Typography>
            <Pagination
              count={Math.ceil(totalUsers / limit)}
              color="primary"
              size="small"
              onChange={handlePageChange}
              page={Number(params.page) || 1}
              siblingCount={isMobile ? 0 : 1}
              boundaryCount={isMobile ? 1 : 2}
              showFirstButton={!isMobile}
              showLastButton={!isMobile}
            />
          </Box>
        </div>
      )}
    </>
  );
};

Results.propTypes = {
  className: PropTypes.string,
  listUser: PropTypes.array.isRequired,
  currentParams: PropTypes.object
};

const useStyles = makeStyles(theme => ({
  root: {
    position: 'relative',
    '&.MuiPaper-elevation1': {
      boxShadow: 'none'
    }
  },
  avatar: {
    marginRight: theme.spacing(2)
  },
  groupAction: {
    display: 'flex',
    alignItems: 'center',
    '& .action': {
      cursor: 'pointer',
      padding: '0 5px',
      '&:hover': {
        color: '#3f51b5'
      }
    }
  },
  minWithColumn: {
    minWidth: '150px'
  }
}));

export default Results;
